import React, { useCallback, useState } from 'react';
import cx from 'classnames';

import { CopyableText } from 'modules/Common/Copy';

import ShipperOrderInfo from './ShipperOrderInfo';
import StopLoad from '../StopLoad';
import ShipperOrderCircle from '../ShipperOrderCircle';

const ShipperOrderRow = ({
  className,
  shipperOrder,
  shipperOrdersSkin = {},
  isStore,
  isLast,
  isXdockJourney,
  currentStop,
}) => {
  const [infoOpened, setInfoOpened] = useState(false);

  const handleOpen = useCallback(() => {
    setInfoOpened((opened) => !opened);
  }, []);

  return (
    <div className={className}>
      <div
        className={cx('shipper-order-row', {
          'shipper-order-row__last': isLast,
        })}
        onClick={handleOpen}
        data-testid="shipper-order-row"
      >
        <div className="shipper-order-row__load-info">
          <div className="shipper-order-row__indicator">
            <ShipperOrderCircle skin={shipperOrdersSkin[shipperOrder?.id]} />
          </div>
          <div className="shipper-order-row__load">
            {(shipperOrder?.loads || []).map((load) => (
              <StopLoad
                key={load.id}
                type_pallets={load.type_pallets}
                real_pallets={load.real_pallets}
                total_weight={load.total_weight}
                item_width={load.item_width}
                item_length={load.item_length}
                item_height={load.item_height}
                equivalent_pallets={load.equivalent_pallets}
                journey_stop_id={load.journey_stop_id}
                extraClassName="stop-load--shipperOrder"
                data-testid="shipper-order-row-load"
              />
            ))}
          </div>
        </div>
        <div className="shipper-order-row__order-id">
          <CopyableText text={`S${shipperOrder?.id}`} />
        </div>
        <div>
          <button className={cx('dropdown-button', { 'dropdown-button__opened': infoOpened })} />
        </div>
      </div>
      {infoOpened && (
        <ShipperOrderInfo
          shipperOrder={shipperOrder}
          isStore={isStore}
          isXdockJourney={isXdockJourney}
          currentStop={currentStop}
        />
      )}
    </div>
  );
};

export default ShipperOrderRow;
